<template>
  <div class>
    <el-dialog title="使用现金券" width="400px" class="repair-dialog" :visible.sync="dialogHide" :before-close="handleClose" :close-on-click-modal='false'>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="券号" prop="couponCode" :rules="$rules.required">
          <el-input v-model="form.couponCode" placeholder="请输入券号" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="激活码" prop="activatCode" :rules="$rules.required">
          <el-input v-model="form.activatCode" placeholder="请输入激活码" maxlength="10"></el-input>
        </el-form-item>
        <p v-if="discountPrice != null" class="color999 ml20">仅支持使用现金券抵扣门店服务费，本单最高可抵扣<span class="blue">{{ discountPrice }}</span>元，注意现金券金额大于最高抵扣金额时仍可使用但是多余部分不退还，请谨慎操作。</p>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="save('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  mixins: [minxin],
  data() {
    return {
      form: {
        couponCode: '',
        activatCode: ''
      },
      salePrice: '',
      discountPrice: null,
      dialogHide: false
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    handleClose() {
      this.dialogHide = false;
      this.$refs['form'].resetFields();
    },
    init() {
      this.$on("set", function (item) {
        console.log(item, 'item');
        if (item.salePrice) this.salePrice = item.salePrice
        if (item.itemType == 'packages' && item.platformPackageItemList &&item.platformPackageItemList.length > 0) {
          let result = item.platformPackageItemList.find(y => y.itemType == 'shopManage')
          if (result) {
            this.discountPrice = result.realPrice || 0;
          } else {
            this.discountPrice = null;
          }
        } else if (item.itemType == 'shopManage') {
          this.discountPrice = item.salePrice || null;
        }
        this.dialogHide = true;
      });
    },
    save (formName) {
      
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.get(this.$url.shopServe.get, this.form).then(res => {
            if (res) {
              console.log(this.salePrice);
              // if (this.salePrice && Number(this.salePrice) < Number(res.faceValue)) {
              //   return this.$message.error("优惠券金额不能大于付款金额")
              // }
              let value = null;
              if (this.discountPrice) {
                value = Number(this.discountPrice) < Number(res.faceValue) ? this.discountPrice : res.faceValue;
              } else {
                value = res.faceValue;
              }
              if (res.status == 'noUse') {
                let parmar = {
                  activatCode: res.activatCode,
                  couponCode: res.couponCode,
                  faceValue: value
                }
                this.dialogHide = false;
                this.$emit("change", parmar);
                this.$refs['form'].resetFields();
              } else {
                return this.$message.error("该代金券" + res.statusCn)
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ .el-dialog {
  margin-top: 0 !important;
  top: 20%;
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  height: 50px;
  box-sizing: border-box;
  line-height: 50px;
  text-align: center;
}
/deep/ .el-dialog__body {
  padding: 40px 40px 40px 10px;
}

/deep/ .el-dialog__footer {
  padding: 0 0 40px;
  text-align: center;
  .btn {
    font-size: 0.18rem;
  }
  .normal-btn {
    margin-right: 50px;
  }
}
</style>